import React from 'react'
import { View } from 'react-native'

import { twMerge } from '../../tailwind/merge'
import { Filter } from './Filter'
import type { SwitchProps } from './types'

export const TRACK_CLASS = 'bg-background-elevation rounded-badge-round p-xs'

type ExpandedProps = SwitchProps & { measureOnly?: boolean }

export const FilterSwitchExpanded = ({ group, testID, measureOnly = false }: ExpandedProps) => (
    <View
        accessibilityRole={measureOnly ? undefined : 'tablist'}
        className={twMerge('flex-row items-center self-start', TRACK_CLASS)}
        testID={testID}
    >
        {group.options.map(option => (
            <Filter
                key={String(option.value)}
                label={option.label}
                selected={option.value === group.value}
                onPress={() => group.onChange(option.value)}
                testID={`${testID}-${String(option.value)}`}
                measureOnly={measureOnly}
            />
        ))}
    </View>
)
